import styles from './TopContainer.module.scss';
import {HashLink} from "react-router-hash-link";
import {Link} from "react-router-dom";

export const TopContainer = () => {
    return (
        <div className={styles['top-container']}>
            <div className={styles['top-bar']}>
                <div className={styles['logo']}>
                    <img
                        className={styles['svg-mark']}
                        src="./sw-logo-mark.svg"
                        alt="stamey-white-logo"
                    />
                    <img
                        className={styles['stamey-white']}
                        src="./Logo.svg"
                        alt="stamey-white-logo"
                    />
                </div>
                <div className={styles['nav']}>
                    <div className={styles['wrapper']}>
                        <ul>
                            <HashLink smooth to="/#home">
                                <li>HOME</li>
                            </HashLink>
                            <HashLink smooth to="/#overview">
                                <li>OVERVIEW</li>
                            </HashLink>
                            <HashLink smooth to="/#about-me">
                                <li>ABOUT ME</li>
                            </HashLink>
                            <HashLink smooth to="/#services">
                                <li>SERVICES</li>
                            </HashLink>
                            <Link to="/contact">
                                <li>CONTACT</li>
                            </Link>
                            <img src="./verticalbar.svg" alt="verticalbar"/>
                            <a href="https://blog.stameywhite.com/" target="_blank"
                               rel="noopener noreferrer">
                                <li>BLOG</li>
                            </a>
                        </ul>

                    </div>
                </div>
            </div>
        </div>
    );
};